import { graphql } from "gatsby"
import { compose } from "recompose"
import ProductDetails from "@views/ProductDetails"
import withTransformMenuData from "@utils/withTransformMenuData"

export const query: any = graphql`
  query ProductDetails(
    $productSlug: String
    $deviceTypeSlug: String
    $seriesSlug: String
  ) {
    contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
      fenixShippingMethods
      prop65Text {
        raw
      }
      countryProhibitedProducts {
        countries
        products {
          slug
        }
        message
      }
    }
    contentfulProduct: contentfulProduct(slug: { eq: $productSlug }) {
      ...ProductDetailsDataFields
    }
    relatedProductsBySeries: allContentfulProduct(
      filter: {
        series: { slug: { eq: $seriesSlug } }
        device: { type: { slug: { eq: $deviceTypeSlug } } }
        slug: { ne: $productSlug }
      }
    ) {
      nodes {
        ...ProductDataFields
      }
    }
  }
`

export default compose(withTransformMenuData)(ProductDetails)
